module.exports = {
      id: "icon-headset-usage",
      viewBox: "0 0 14.219 15.009",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#icon-headset",
      toString: function () {
        return this.url;
      }
    }